import { Box } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { useFilteredEmployeeCount, useIsNoFilterSelected } from 'components/Views/Hooks/dataHooks';
import { useDispatch } from 'react-redux';
import {
  VIEWS_SUB_SCREENS,
  resetView,
  setIsSaveViewModalOpen,
  setViewsSubScreen,
  useViewSubScreen,
  setViewAction,
  useView,
  resetViewsPanel,
  useViewsPanelState,
} from 'reducers/viewsSlice';

import { ArrowLeft } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { Tooltip } from 'uiToolkitV1/Tooltip';

const ApplyButton = styled(Button)`
  margin-left: auto;
`;
const CancelButton = styled(Button)`
  margin-left: 12px;
`;
const BackButton = styled(Button)`
  margin-right: auto;
  & p {
    display: flex;
    align-items: center;
  }
`;

const SavePageFooter = () => {
  const dispatch = useDispatch();
  const { name } = useView();

  const disableSaveAndApply = useIsNoFilterSelected();
  const { data: filteredEmployeeCount } = useFilteredEmployeeCount();

  let tooltTipText = '';
  if (!name) {
    tooltTipText = 'Please provide a name for this view.';
  } else if (disableSaveAndApply) {
    tooltTipText = `You can either use additional filters or directly 
    access this page from the left navigation.`;
  } else if (!filteredEmployeeCount) {
    tooltTipText = 'This view will result in zero employees, please change the filters.';
  }

  return (
    <>
      <BackButton variant="tertiary" onClick={() => dispatch(setViewsSubScreen(VIEWS_SUB_SCREENS.NONE))}>
        <ArrowLeft boxSize="24px" />
        <span>Back</span>
      </BackButton>
      <Tooltip label={tooltTipText} isDisabled={!tooltTipText}>
        <Box>
          <ApplyButton isDisabled={!name || disableSaveAndApply} onClick={() => dispatch(setIsSaveViewModalOpen(true))}>
            Save View
          </ApplyButton>
        </Box>
      </Tooltip>
    </>
  );
};

const ApplyFiltersFooter = () => {
  const dispatch = useDispatch();
  const { onCancel: onCancelTopOne } = useViewsPanelState();

  const disableSaveAndApply = useIsNoFilterSelected();

  const onCancel = () => {
    dispatch(resetViewsPanel());
    dispatch(resetView());
    dispatch(setViewAction(null));
    onCancelTopOne && onCancelTopOne();
  };

  return (
    <>
      <Button variant="tertiary" mr="auto" onClick={onCancel}>
        Cancel
      </Button>
      <Tooltip
        label={`You can either use additional filters or directly 
access this page from the left navigation.`}
        isDisabled={!disableSaveAndApply}
      >
        <Box>
          <ApplyButton
            disabled={disableSaveAndApply}
            onClick={() => dispatch(setViewsSubScreen(VIEWS_SUB_SCREENS.SAVE))}
          >
            Next
          </ApplyButton>
        </Box>
      </Tooltip>
    </>
  );
};

export const EditViewFooter = () => {
  const viewsScreen = useViewSubScreen();

  if (viewsScreen === VIEWS_SUB_SCREENS.UPLOAD_CSV) {
    return null;
  }

  if (viewsScreen === VIEWS_SUB_SCREENS.SAVE) {
    return <SavePageFooter />;
  }

  return <ApplyFiltersFooter />;
};
